/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';

const getAllMintpacks = (state: any) => state.getIn(['renderViewReducer', 'allMintPacks']);
const getRenderedpacks = (state: any) => state.getIn(['renderViewReducer', 'recommedndedMintpacks']);

const RenderViewSelector = createSelector(
    [getAllMintpacks,getRenderedpacks],
    (allMintPacks, recommedndedMintpacks) => ({
        allMintPacks, recommedndedMintpacks
    })
);

export default RenderViewSelector;